import type { GetTweetById200MediaItemDimensions } from './getTweetById200MediaItemDimensions';
import type { GetTweetById200MediaItemType } from './getTweetById200MediaItemType';

export type GetTweetById200MediaItem = {
  dimensions?: GetTweetById200MediaItemDimensions;
  id: string;
  mimeType?: string;
  size?: number;
  thumbnailUrl?: string;
  type: GetTweetById200MediaItemType;
  url: string;
};
